import * as React from "react";
import { Container } from "@mantine/core";
import styled from "styled-components";
const StyledContainer = styled(Container)`
  max-width: none;
  padding-left: 15px;
  padding-right: 15px;
`;
const Grid = ({ fluid = false, className, children }) => /* @__PURE__ */ React.createElement(StyledContainer, { fluid, className }, children);
export default Grid;
